var exports = {
  "H": "x0a7806d5--d672a8--action-buttons",
  "x": "x0a7806d5--d672a8--button",
};

module.exports = exports;
